<template>
  <div class="btn-group-vertical d-block">
    <button
      v-for="(day, index) in daysOfWeek"
      :key="index"
      @click="toggleDay(index)"
      type="button"
      :class="selectedDaysOfWeek.has(index) ? 'active ' : ''"
      class="btn btn-dark text-left px-4"
      autocomplete="off"
    >
      {{day.name}}
    </button>
    <div class="px-1 mb-1">
      <a href="#" @click.prevent="pickingDone()">
        <div class="bg-gray text-center text-primary clickable rounded px-4 py-3">{{$t('Select')}}</div>
      </a>
    </div>
    <div class="px-1 mb-1">
      <a href="#" @click.prevent="cancel()">
        <div class="bg-gray text-center text-danger clickable rounded px-4 py-3">{{$t('Cancel')}}</div>
      </a>
    </div>
  </div>
</template>

<script>
import days from '@/utils/days'

export default {

  name: 'MultiDaysOfWeekPicker',

  props: {
    onChange: Function,
    onPickingDone: Function,
    initValue: Set
  },

  created () {},

  data () {
    return {
      selectedDaysOfWeek: this.initValue ? this.initValue : Set(),
      originalSelection: this.initValue ? new Set(this.initValue) : new Set(),
      daysOfWeek: days
    }
  },

  methods: {
    pickingDone () {
      if (this.onPickingDone) { this.onPickingDone(this.selectedDaysOfWeek) }
    },
    cancel () {
      this.selectedDaysOfWeek = new Set(this.originalSelection)
      if (this.onChange) { this.onChange(this.selectedDaysOfWeek) }
      if (this.onPickingDone) { this.onPickingDone(this.selectedDaysOfWeek) }
    },
    toggleDay (index) {
      if (this.selectedDaysOfWeek.has(index)) {
        this.selectedDaysOfWeek.delete(index)
      } else {
        this.selectedDaysOfWeek.add(index)
      }
      this.selectedDaysOfWeek = new Set(this.selectedDaysOfWeek)
      if (this.onChange) { this.onChange(this.selectedDaysOfWeek) }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/MultiDaysOfWeekPicker.vue